import { mixed, object, string } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import "@lib/messageComposition/chatMessaging/yupHelper";
import type { SHARED_CONSTANTS_RICH_CARD_TYPES } from "@lib/shared_constants";
import sharedConstants from "@lib/shared_constants";

import { getRcsBaseRichCardSchema } from "./rcsBaseRichCardSchema";

export const getRcsTextRichCardSchema = (t: I18nT<"rcs-composer">, isTwilioProvider?: boolean) =>
  getRcsBaseRichCardSchema(t, isTwilioProvider)
    .concat(
      object({
        rich_card_type: mixed<SHARED_CONSTANTS_RICH_CARD_TYPES["TEXT"]>()
          .oneOf([sharedConstants.RCS.RICH_CARD_TYPES.TEXT])
          .required(),
        title: string()
          .maxLengthIgnoringLiquid(
            sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_RICH_CARD_TITLE,
            t("rcs-rich-card-title-length-error", "Title exceeds the character limit")
          )
          .required(t("rcs-rich-card-title-required-error", "Title cannot be blank")),
        body: string()
          .maxLengthIgnoringLiquid(
            sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_RICH_CARD_DESCRIPTION,
            t("rcs-rich-card-description-length-error", "Description exceeds the character limit")
          )
          .required(t("rcs-rich-card-description-required-error", "Description cannot be blank")),
      })
    )
    .noUnknown();
